import request from '@/utils/request'
export default {
    query(data) {
        return request({
            url: '/manufactor/query',
            method: 'POST',
            data
        })
    },
}
